export class Reward {
  id: number;
  code: string;
  type: string;
  status: string;
  value: string;
  createdDate: string;
  updatedDate: string;

  constructor(fields) {
    Object.assign(this, fields);
  }
}


export function createReward(blob: any): Reward {
  return new Reward({
    id: blob.id,
    code: blob.reward_code,
    type: blob.reward_type,
    status: blob.reward_status,
    value: blob.reward_value,
    createdDate: blob.create_date,
    updatedDate: blob.update_date,
  });
}
